// extracted by mini-css-extract-plugin
module.exports = {"mobile_banner_slide":"mobile_banner_mobile_banner_slide__MYIDq","banner_images":"mobile_banner_banner_images__I4keI"};